import { useCallback } from 'react';

import { gql, useMutation } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const UPDATE_ACTION_MUTATION = gql`
  mutation UpdateActionTaken($input: ActionTaken!) {
    updateActionTaken(input: $input) {
      uuid
      status
    }
  }
`;

export default function useActionTakenUpdate(instanceUuid) {
  const [updateActionTaken, { errors, loading }] = useMutation(
    UPDATE_ACTION_MUTATION,
    {
      noThrow: true
    }
  );

  const saveActionTaken = useCallback(
    (status) => {
      updateActionTaken({
        variables: {
          input: {
            status: status || 'cta-clicked',
            uuid: instanceUuid
          }
        }
      });
    },
    [updateActionTaken, instanceUuid]
  );

  useError(errors);

  return {
    hasError: !!errors?.[0],
    loading,
    saveActionTaken
  };
}
